import React, { Component } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import '../../content/css/ContractTypeDropdown.css';

const CONTRACT_TYPES = [
    "ProcurementAgreement",
    "CustomerAgreement",
    "Unknown",
    "NDA_Customer",
    "NDA_Seller",
    "NDA_Mutual",
    "EULA_Customer",
    "EULA_Seller",
    "DistributionAgreement_Customer",
    "DistributionAgreement_Seller",
    "DPA_Controller",
    "DPA_Processor",
    "LicenseAgreement_Customer",
    "LicenseAgreement_Seller",
    "SourcingOfGoods_Customer",
    "SourcingOfGoods_Seller",
    "Services_Customer",
    "Services_Seller",
    "PersonalServices_Customer",
    "PersonalServices_Seller",
    "CarrierAgreement",
    "BrokerAgreement",
];

export default class ContractTypeDropdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            type: this.props.type
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.type !== this.props.type) this.setState({ type: this.props.type });
    }

    handleSelect = (type) => {
        this.setState({ type });
        this.props.onChange(type);
    }

    getName(type) {
        switch (type) {
            case "ProcurementAgreement": return "Procurement Agreement";
            case "CustomerAgreement": return "Customer Agreement";
            case "NDA_Customer": return "NDA - receiving information";
            case "NDA_Seller": return "NDA - giving information";
            case "NDA_Mutual": return "NDA - giving & receiving information";
            case "EULA_Seller": return "EULA - Seller";
            case "EULA_Customer": return "EULA - Customer";
            case "DistributionAgreement_Customer": return "Distribution Agreement - Customer";
            case "DistributionAgreement_Seller": return "Distribution Agreement - Seller";
            case "DPA_Controller": return "DPA - Controller";
            case "DPA_Processor": return "DPA - Processor";
            case "LicenseAgreement_Customer": return "License Agreement - Customer";
            case "LicenseAgreement_Seller": return "License Agreement - Seller";
            case "SourcingOfGoods_Customer": return "Sourcing of Goods - Customer";
            case "SourcingOfGoods_Seller": return "Sourcing of Goods - Seller";
            case "Services_Customer": return "Online Services - Customer";
            case "Services_Seller": return "Online Services - Seller";
            case "PersonalServices_Customer": return "Personal Services - Customer";
            case "PersonalServices_Seller": return "Personal Services - Seller";
            case "CarrierAgreement": return "Carrier Agreement";
            case "BrokerAgreement": return "Broker Agreement";
            case "Unknown": return "Unknown";
            default: return "Unknown";
        }
    }

    renderMenuItems = () => {
        return CONTRACT_TYPES.map((x, i) => (
            <MenuItem eventKey={i} active={this.state.type === x} onSelect={() => this.handleSelect(x)}>
                {this.getName(x)}
            </MenuItem>
        ));
    }

    render() {
        return (
            <div className="contract-type-dropdown">
                <DropdownButton title={this.getName(this.state.type)} id={`dropdown-contract-type`} >
                    {this.renderMenuItems()}
                </DropdownButton>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CategoryView/ContractTypeDropdown.js